export default __webpack_public_path__ + "static/media/tools_icon.7d96ffad.svg";